export default __webpack_public_path__ + "static/media/CT_Amazon.4a0abdaa.png";